import { render, staticRenderFns } from "./Comprar.html?vue&type=template&id=12678308&scoped=true&"
import script from "./Comprar.vue?vue&type=script&lang=js&"
export * from "./Comprar.vue?vue&type=script&lang=js&"
import style0 from "./Comprar.scss?vue&type=style&index=0&id=12678308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12678308",
  null
  
)

export default component.exports